// extracted by mini-css-extract-plugin
export default {"imageWrapper":"KE-z","hovered":"LE-z","hoverImage":"ME-z","mainImage":"NE-z","imageNoBackground":"OE-z","fullSizeImage":"PE-z"};